import Vue from 'vue'
import './cube-ui'
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
// import 'lib-flexible/flexible'

import animated from 'animate.css/animate.css'
Vue.use(animated);

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
// Vue.use(VueAwesomeSwiper)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(Vant)
Vue.config.productionTip = false

Vue.config.ignoredElements = [
  'wx-open-launch-app',
];

import axios from 'axios'
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
